import { connect, ConnectedProps } from 'react-redux';
import { withRouter } from 'react-router-dom';

import MyOrdersDetails from '../components/MyOrdersDetailsComponent';

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = () => {
  return {};
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromReduxMyOrders = ConnectedProps<typeof connector>;

export default withRouter(connector(MyOrdersDetails));
